<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="mb-5 w-100" v-show="!loading">
                    <button class="btn btn-primary float-right" @click="onAddNewPromotionClick" id="btnAddPromotion">
                        Add New Promotion
                    </button>
                </div>
                <div v-show="!loading">
                    <data-table :headings="promotionsHeadings" :data="promotions" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onPromotionActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <from-date-to-date-pickers  :title="'Active Date'"
                                                                    :fromDate="filter.fromDateCreated"
                                                                    :toDate="filter.toDateCreated"
                                                                    :elementId="'promotionDateFilter'"
                                                                    :dateFormat="'dd/MM/yyyy'"
                                                                    @clearDatePicker="onDateFilterClearClick"
                                                                    @fromDateSelected="onFromDateCreatedSelect"
                                                                    @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="pr-3 float-right">
                                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                           :componentId="'promotionFilterRadioButtons'"
                                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="promotionMarkAsActiveInactiveModal.heading"
                :modalId="promotionMarkAsActiveInactiveModal.modalId"
                :isSaving="promotionMarkAsActiveInactiveModal.isSaving"
                :showModal="promotionMarkAsActiveInactiveModal.showModal"
                :isActive="promotionMarkAsActiveInactiveModal.isActive"
                @closeClicked="promotionMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    
</div>
